/* Le Grom — sticky mobile Add-to-Cart bar logic. Pairs with snippets/lg-sticky-atc.liquid. */
(function () {
  function init() {
    var el = document.querySelector('.lg-sticky');
    if (!el || el.__lgInit) return;
    var sectionId = el.getAttribute('data-section-id');
    var mainBtn =
      document.getElementById('ProductSubmitButton-' + sectionId) ||
      document.querySelector('[id^="ProductSubmitButton-"]');
    if (!mainBtn) return;
    el.__lgInit = true;

    document.body.appendChild(el); // guarantee position:fixed is viewport-anchored
    el.hidden = false;

    var addBtn = el.querySelector('[data-lg-sticky-add]');
    var priceEl = el.querySelector('[data-lg-price]');
    var mainPrice = document.querySelector(
      '[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular, [id^="price-"] .price-item'
    );

    function update() {
      var r = mainBtn.getBoundingClientRect();
      // Show once the real Add-to-Cart has scrolled above the top of the viewport.
      el.classList.toggle('is-visible', r.bottom < 0);
      if (priceEl && mainPrice) {
        var t = mainPrice.textContent.trim();
        if (t) priceEl.textContent = t;
      }
      var disabled = mainBtn.hasAttribute('disabled');
      addBtn.disabled = disabled;
      addBtn.textContent = disabled ? 'Unavailable' : 'Add to cart';
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function () { update(); }, { threshold: 0 }).observe(mainBtn);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    addBtn.addEventListener('click', function () { mainBtn.click(); });
    update();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
